import { useState, useEffect } from 'react';

const MULTI_OUTPUT_TYPES = {
  'n8n-nodes-base.if': 2,
  'n8n-nodes-base.switch': 4,
};

const CATEGORY_LABELS = {
  trigger: 'Triggers',
  transform: 'Transform',
  output: 'Output',
  input: 'Input',
  schedule: 'Schedule',
  organization: 'organization',
};

const getCategory = (node) => {
  const group = node.group || node.nodeDescription?.group || [];
  if (group.length > 0) {
    return CATEGORY_LABELS[group[0]] || group[0];
  }
  return 'Other';
};

export const transformNodeTypes = (apiNodes) => {
  if (!apiNodes || !Array.isArray(apiNodes)) return [];

  const seenKeys = new Set();
  const seenLabels = new Set();
  const results = [];

  for (const node of apiNodes) {
    if (!node.name) continue;

    const key = node.name;
    const label = node.displayName || node.defaults?.name || node.nodeDescription?.defaults?.name || key;

    if (seenKeys.has(key) || seenLabels.has(label)) continue;

    // Skip "Tool" variants if the base node already exists (e.g. "AWS S3 Tool" when "AWS S3" exists)
    const baseLabel = label.replace(/ Tool$/, '');
    if (baseLabel !== label && seenLabels.has(baseLabel)) continue;

    seenKeys.add(key);
    seenLabels.add(label);

    const outputs = MULTI_OUTPUT_TYPES[node.name];
    results.push({
      key,
      type: node.name,
      typeVersion: node.version || node.nodeDescription?.version || 1,
      label,
      description: node.description || label,
      category: getCategory(node),
      icon: '🔧',
      iconUrl: node.iconUrl || node.nodeDescription?.iconUrl || null,
      defaultParameters: {},
      properties: node.properties || node.nodeDescription?.properties || [],
      ...(outputs ? { outputs } : {}),
    });
  }

  return results;
};

const useNodeTypes = () => {
  const [nodeTypes, setNodeTypes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    import('./nodes.json').then((module) => {
      const raw = module.default || module;
      const nodes = Array.isArray(raw) ? raw : [];
      const transformed = transformNodeTypes(nodes);

      if (transformed.length > 0) {
        setNodeTypes(transformed);
      }

      setLoading(false);
    }).catch((error) => {
      console.error('Failed to load node types:', error);
      setLoading(false);
    });
  }, []);

  return { nodeTypes, loading };
};

export default useNodeTypes;
